import { Controller } from 'stimulus'

function getSelectValues(el) {
  return Array.from(el.selectedOptions, o => o.value)
}

const registry = {
  items: new Map(),
  add(key, val) {
    if (!this.items.has(key)) {
      this.items.set(key, new Set())
    }
    this.items.get(key).add(val)
  },
  get(key) {
    return this.items.get(key) || new Set()
  },
  remove(val) {
    Array.from(this.items.values()).forEach(set => {
      set.delete(val)
    })
  }
}

export default class extends Controller {
  static targets = [ 'select' ]
  static values = { loadingLabel: String, emptyLabel: String }

  connect() {
    this.element.addEventListener('change', this.handle, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener('change', this.handle)
  }

  selectTargetConnected(element) {
    document.querySelectorAll(element.dataset.dependencySelector).forEach(dep => {
      registry.add(dep, element)
    })
  }

  selectTargetDisconnected(element) {
    registry.remove(element)
  }

  handle = ({ target }) => {
    registry.get(target).forEach(el => {
      this.#update(target, el)
    })
  }

  #update = async (source, select) => {
    const params = new URLSearchParams()
    getSelectValues(source).forEach(v => {
      params[source.multiple ? "append" : "set"](source.name, v)
    })

    const url = new URL(window.location.origin + select.dataset.sourceUrl)
    url.search = params.toString()

    const firstOption = select.options[0]
    select.innerHTML = this.loadingOption
    select.prepend(firstOption)

    try {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error("HTTP status " + response.status)
      }
      const content = await response.text()
      setTimeout(() => {
        select.innerHTML = content || this.emptyOption
      }, 1)
    } catch (e) {
      setTimeout(() => {
        select.innerHTML = this.emptyOption
      }, 1)
    } finally {
      select.prepend(firstOption)
      select.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  get loadingOption() {
    return this.makeDisabledOption(this.loadingLabelValue)
  }

  get emptyOption() {
    return this.makeDisabledOption(this.emptyLabelValue)
  }

  makeDisabledOption(label) {
    return "<option disabled>" + label + "</option>"
  }
}
